import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import Joyride from 'react-joyride';
import Chart from 'react-apexcharts';
import PageLoading from '../common/componentsV2/elements/PageLoading';
import {
  AvvisoAlert,
  RcQuotesStyles,
} from './RcQuotes.styles';
import LambdaLoaderCard from '../common/components/redesignComponents/ResultPageComponents/v2/LambdaLoaderCard';
import {
  addQuoteAutoToCart,
  addVehicleAmount,
  fetchAutoReport,
  loadAutoQuotes,
  removeQuoteAutoFromCart,
  resetAutoQuotes,
  silentLoadAutoQuotes,
  updateAutoQuotesData,
  updateSortByAuto,
} from '../features/insuranceRequests/insuranceRequestsActions';
import { confirmAlert, generalAlertError } from '../common/utils/alerts';
import { EstimateContainer } from '../common/components/redesignComponents/common/Redesign.styles';
import GuaranteesModal from '../common/components/redesignComponents/Modal/GuaranteesModal';
import { V2FontImport } from '../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import VehicleSummaryCard from '../common/components/redesignComponents/ResultPageComponents/v2/VehicleSummaryCard';
import QuoteCostSummaryCard from '../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  TonalActionButton,
  OutlineActionButton,
  ActionButtonBadge,
  ActionButtonsRow,
} from '../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChartIcon, ChatIcon } from '../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
// import { SellingDistanceModal } from '../common/components/elements/SellingDistanceModal/SellingDistanceModal';
// import { SellingDistanceLink } from '../common/components/elements/SellingDistanceLink';
import { coveragesUtil } from '../utils/coverages';
import ErrorComponent from '../common/components/ErrorComponent';
import ConversationModal from '../common/components/redesignComponents/Modal/ConversationModal';
// import { useTourContext } from '../context/useTourContext';
// import { handleCallbackRcQuotes } from '../common/utils/joyrideCallbacks';
// import { rcQuotesSteps } from '../common/utils/joyrideSteps';
import {
  RiskCard,
  RiskContainer,
  RiskButton,
  VehicleValueBadge,
} from '../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
import { primaQuoteTypes, primaMergeQuoteTypes } from '../common/constants';
import ModalQuotes from '../common/components/redesignComponents/ResultPageComponents/ModalQuotes';
import ButtonComponentLogic from '../common/components/redesignComponents/ResultPageComponents/ButtonComponentLogic';
import SelectedQuotesCards from '../common/components/redesignComponents/ResultPageComponents/SelectedQuotesCards';
import ButtonComponentLogicPrima from '../common/components/redesignComponents/ResultPageComponents/ButtonComponentLogicPrima';
import SelectedQuotesCardsPrima from '../common/components/redesignComponents/ResultPageComponents/SelectedQuotesCardsPrima';
import ModalQuotesPrima from '../common/components/redesignComponents/ResultPageComponents/ModalQuotesPrima';
import {
  riskCardPrimaStyles,
  riskCardStyles,
} from '../common/components/redesignComponents/ResultPageComponents/RcQuotesModal.style';
import { FormInputText } from '../common/formInputsV2/FormInputText';
import quotationsAxe from '../services/axios-client/quotationsAxeClient';
import FailedQuotationsComponent from '../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

// ? Helpers
const isVehicleValueType = (typeId) => ['furto_incendio', 'eventi_naturali', 'eventi_socio_politici'].includes(typeId);

const shouldRenderRiskCard = (processingQuote, typeId, quotations) => {
  if (!processingQuote) return true;

  const { company_id } = processingQuote;

  if (company_id !== 9 && typeId === 'rc_transportati_minori') return false;

  const excludedTypes = [
    'kasko',
    'bonus_protetto',
    'pacchetto_protezione_valore',
    'protezione_mobilita',
    'estensione_deluxe',
    'quattrozampe_a_bordo',
    'pacchetto_eco',
  ];

  if (typeId === 'kasko') {
    const hasNobisKasko = Array.isArray(quotations?.kasko)
      && quotations.kasko.some((q) => q.company_id === 1001);
    if (hasNobisKasko) return true;
  }

  if (company_id !== 1000 && excludedTypes.includes(typeId)) {
    // Facile bundles can ship these coverages under any insurer (Allianz
    // Direct, Linear, Genertel, …). When a sibling quotation row exists for
    // the same insurer, the broker should be able to add it to the cart.
    const sameCompanySibling = Array.isArray(quotations?.[typeId])
      && quotations[typeId].some((q) => q.company_id === company_id);
    if (!sameCompanySibling) return false;
  }

  return true;
};

function RiskCardBlock({
  type,
  requestInfo,
  riskQuotations,
  processingQuote,
  removeItemFromCart,
  refresh,
  guaranteesPrima,
}) {
  return (
    <RiskCard
      className={riskCardStyles(
        requestInfo,
        type,
        riskQuotations,
      )}
    >
      <div className={requestInfo?.vehicle && requestInfo?.vehicle?.value !== null && isVehicleValueType(type?.id) ? 'd-flex justify-content-between w-100' : 'me-auto'}>
        <h5>{type.name}</h5>
        <div>
          {requestInfo.vehicle && requestInfo.vehicle.value !== null && isVehicleValueType(type?.id) && (
            <VehicleValueBadge>
              <small>
                Valore Veicolo:
              </small>
              <small>
                {Number(requestInfo.vehicle.value).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                {' '}
                €
              </small>
            </VehicleValueBadge>
          )}
        </div>
      </div>
      <SelectedQuotesCards
        processingQuote={processingQuote}
        type={type}
        riskQuotations={riskQuotations}
        refresh={refresh}
        requestInfo={requestInfo}
        guaranteesPrima={guaranteesPrima}
      />
      <ButtonComponentLogic
        type={type}
        requestInfo={requestInfo}
        processingQuote={processingQuote}
        removeItemFromCart={removeItemFromCart}
        riskQuotations={riskQuotations}
      />
    </RiskCard>
  );
}

function RiskCardBlockPrima({
  quote, processingQuote, requestInfo, primaQuoteTypes,
}) {
  return (
    <RiskCard
      className={riskCardPrimaStyles(
        primaQuoteTypes.find(
          (type) => type.id === quote.slug,
        ),
        processingQuote,
      )}
    >
      <div className="me-auto">
        <h5>
          {
            primaQuoteTypes.find(
              (type) => type.id === quote.slug,
            )?.name
          }
        </h5>
      </div>
      <SelectedQuotesCardsPrima
        processingQuote={processingQuote}
        type={primaQuoteTypes.find(
          (type) => type.id === quote.slug,
        )}
      />

      <ButtonComponentLogicPrima
        type={primaQuoteTypes.find(
          (type) => type.id === quote.slug,
        )}
        processingQuote={processingQuote}
        requestInfo={requestInfo}
      />
    </RiskCard>
  );
}

function VehicleValueInputCard({
  type,
  requestInfo,
  vehicleAmount,
  setVehicleAmount,
  saveVehicleAmount,
  riskQuotations,
}) {
  return (
    <RiskCard className={riskCardStyles(requestInfo, type, riskQuotations)}>
      <div className="me-auto">
        <h5>{type.name}</h5>
      </div>
      <div className="my-auto">
        <FormInputText
          label="Inserisci valore del veicolo"
          type="number"
          value={vehicleAmount[type.id]}
          onWheel={(e) => e.target.blur()}
          onChange={(value) => setVehicleAmount({ ...vehicleAmount, [type.id]: value })}
        />
      </div>
      {vehicleAmount[type.id].length >= 3 && (
        <RiskButton onClick={() => saveVehicleAmount(type)}>
          Salva
        </RiskButton>
      )}
    </RiskCard>
  );
}

function RcQuotes() {
  const navigate = useNavigate();
  const { requestToken } = useParams();
  const [showGuaranteesModal, setShowGuaranteesModal] = useState(false);
  const [showConsulenzaReport, setShowConsulenzaReport] = useState(false);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [vehicleAmount, setVehicleAmount] = useState({
    furto_incendio: '',
    eventi_naturali: '',
    eventi_socio_politici: '',
  });

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const clearQuotesIntervalRef = useRef(null);
  const requestInfoRef = useRef(null);
  const [intervalQuotes, setIntervalQuotes] = useState(null);
  const checkResultsIntervalRef = useRef(null);
  const isPollingStartedRef = useRef(false);
  const state = useSelector((store) => store.insuranceRequests.auto_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    failedQuotes,
    preventivas_quotes,
    sortBy,
    error,
    report,
    loadingReport,
    quotations,
    addingQuote,
    processingQuote,
    riskQuotations,
    thread,
    est_provvigioni,
  } = state;
  const [chartData, setChartData] = useState([]);
  const [chartCategories, setChartCategories] = useState([]);
  // const [showSellingDistanceModal, setShowSellingDistanceModal] = useState(false);
  const [counter, setCounter] = useState(180);
  const [currentQuotes] = useState('diretta');
  const [allScrapperResulsGotten, setAllScrapperResulsGotten] = useState({
    genial_received: false,
    verti_received: false,
    linear_received: false,
    nobis_received: false,
    facile_received: false,
    bene_assicurazioni_received: false,
  });
  // const [isOlderThan10years, setIsOlderThan10years] = useState(false);
  // const [orderedQuotes, setOrderedQuotes] = useState([]);
  // ? diretta = Greenia Companies
  // ? indiretta = Preventivass Companies
  // ? quotazioni = All Preventivass Quotes
  // const {
  //   setState,
  //   state: { run, showBeacon, steps },
  // } = useTourContext();
  const silentRefresh = () => silentLoadAutoQuotes(requestToken);

  // const handleCurrentQuotesDisplay = (val) => {
  //   setCurrentQuotes(val);
  // };

  const checkScrapperResponses = async () => {
    const response = await quotationsAxe.get(`/quotations/check-quote-results/${requestInfo.id}`);
    if (response.status !== 200) {
      console.log('Failed to check quotation results response!!');
      return false;
    }

    setAllScrapperResulsGotten({
      genial_received: response.data.genial_received,
      verti_received: response.data.verti_received,
      linear_received: response.data.linear_received,
      nobis_received: response.data.nobis_received,
      facile_received: response.data.facile_received,
      bene_assicurazioni_received: response.data.bene_assicurazioni_received,
    });
    if (requestInfo.product_id == 1) {
      if (
        response.data.genial_received === true
        || response.data.verti_received === true
        || response.data.linear_received === true
        || response.data.nobis_received === true
        || response.data.facile_received === true
        || response.data.bene_assicurazioni_received === true
      ) {
        silentRefresh();
      }
    } else if (
      response.data.genial_received === true
      || response.data.linear_received === true
      || response.data.facile_received === true
      || response.data.verti_received === true
    ) {
      silentRefresh();
    }
    return response.data.received_all;
  };

  const guaranteesPrima = (quote) => {
    const guarantees = quote.quotation_data_prima_guarantees
      .map((guarantee) => guarantee.slug)
      .filter((g) => g != 'rca' && g != 'furto_incendio');
    if (
      quote.quotation_data_prima_guarantees.find(
        (qg) => qg.slug == 'furto_incendio',
      ) != undefined
    ) {
      guarantees.push('incendio');
      guarantees.push('furto');
    }
    return guarantees;
  };

  // const getSellingDistanceLink = () => {
  //   const vehicleByProduct = {
  //     1: 'auto',
  //     3: 'autocarro',
  //   };

  //   return `${SELLING_DISTANCE_URL}/request/${requestInfo.distance_token}/${vehicleByProduct[requestInfo.product_id]}/results`;
  // };

  // const copySellingDistanceLink = async () => {
  //   const link = getSellingDistanceLink();

  //   await navigator.clipboard.writeText(link);
  //   generalAlertSuccess('Il collegamento e stato copiato');
  // };

  // useEffect(() => {
  //   rcQuotesSteps(quotes, requestInfo, setState);
  // }, [quotes, requestInfo]);

  // useEffect(() => {
  //   if (localStorage.getItem('quoteNewResult') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('quoteNewResult')]);

  // const firePurchaseTour = () => {
  //   localStorage.removeItem('quoteNewResult');
  //   setState({ run: true });
  // };

  const refresh = () => loadAutoQuotes(requestToken);

  useEffect(() => {
    loadAutoQuotes(requestToken);

    return () => {
      resetAutoQuotes();
    };
  }, []);

  const clearQuotesInterval = () => {
    if (intervalQuotes !== null) {
      clearInterval(intervalQuotes);
      setIntervalQuotes(null);
    }
  };

  clearQuotesIntervalRef.current = clearQuotesInterval;
  requestInfoRef.current = requestInfo;

  const sortQuotes = (sortBy) => {
    updateSortByAuto(sortBy);
  };

  useEffect(() => {
    const iq = setInterval(() => {
      const requestInfo = requestInfoRef.current;
      if (requestInfo !== null && requestInfo.product_id == 1) {
        if (requestInfo.with_preventivas === null) {
          loadAutoQuotes(requestToken);
        }

        if (requestInfo.with_preventivas !== null) {
          clearQuotesIntervalRef.current();
        }
      }
    }, 10000);

    setIntervalQuotes(iq);

    return () => {
      clearQuotesIntervalRef.current();
    };
  }, []);

  useEffect(() => {
    if (!requestInfo?.id) return undefined;

    // Renewals already carry all company quotations — no scrapers are called, so skip polling.
    if (requestInfo.is_renewal) return undefined;

    // Reset polling flag when request ID changes (new request)
    isPollingStartedRef.current = false;

    // Clear any existing interval
    if (checkResultsIntervalRef.current) {
      clearInterval(checkResultsIntervalRef.current);
      checkResultsIntervalRef.current = null;
    }

    // Check scrapper responses once and start polling if needed
    const initializePolling = async () => {
      const allReceived = await checkScrapperResponses();

      // Start interval only if not already polling and not all results received
      if (!isPollingStartedRef.current && !allReceived) {
        isPollingStartedRef.current = true;

        checkResultsIntervalRef.current = setInterval(async () => {
          const allReceivedInInterval = await checkScrapperResponses();
          if (allReceivedInInterval && checkResultsIntervalRef.current) {
            clearInterval(checkResultsIntervalRef.current);
            checkResultsIntervalRef.current = null;
            isPollingStartedRef.current = false;
          }
        }, 10000);
      }
    };

    initializePolling();

    return () => {
      if (checkResultsIntervalRef.current) {
        clearInterval(checkResultsIntervalRef.current);
        checkResultsIntervalRef.current = null;
        isPollingStartedRef.current = false;
      }
    };
  }, [requestInfo?.id, requestInfo?.is_renewal]);

  useEffect(() => {
    if (requestInfo !== null && requestInfo.quotations) {
      updateAutoQuotesData(requestInfo, sortBy, preventivas_quotes, quotations, quoteTypes);
    }
  }, [requestInfo, sortBy]);

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const modifyData = () => {
    navigate(`/quote/${requestInfo.product_id == 1 ? 'auto' : 'autocarro'}`, {
      state: { requestToken },
    });
  };

  const getAutoReportData = () => {
    fetchAutoReport(requestInfo.id);
  };

  const toggleAutoReportChart = () => {
    setShowConsulenzaReport(!showConsulenzaReport);
    getAutoReportData();
  };

  useEffect(() => {
    if (report !== null) {
      const newArrData = [];
      const newArrCats = [];
      for (let i = 0; i < report.length; i++) {
        const item = report[i];

        newArrData.push(parseFloat(item.value));
        newArrCats.push(item.name);
      }

      setChartData(newArrData);
      setChartCategories(newArrCats);
    }
  }, [report]);

  const optionsChart = {
    chart: {
      type: 'bar',
    },
    plotOptions: {
      bar: {
        distributed: true,
        dataLabels: {
          position: 'top',
        },
      },
    },
    colors: chartData.map((value) => {
      if (value >= 66) return '#FF0000'; // Red
      if (value <= 25) return '#00A651'; // Green
      return '#FFE81A'; // Yellow
    }),
    dataLabels: {
      enabled: true,
      formatter(val) {
        return `${val}%`;
      },
      offsetY: -20,
      style: {
        fontSize: '14px',
        colors: ['#282828'],
      },
    },
    xaxis: {
      categories: chartCategories,
    },
  };

  const series = [
    {
      name: 'Consulenza - Report',
      data: chartData,
    },
  ];

  // const leadSourceName = {
  //   0: 'Intermediario',
  //   1: 'Sito publico',
  // };

  // useEffect(() => {
  //   if (requestInfo && requestInfo.is_expired === true && requestInfo.request_token === requestToken) {
  //     navigate(`/quote/${requestInfo.product_id == 1 ? 'auto' : 'autocarro'}`, {
  //       state: { requestToken },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [requestInfo, requestToken]);

  // useEffect(() => {
  //   if (requestInfo && requestInfo.vehicle) {
  //     const year = new Date().getFullYear();
  //     const month = new Date().getMonth();
  //     if (requestInfo.vehicle.vehicle_month && requestInfo.vehicle.vehicle_year) {
  //       // ? Get diff from vehicle year and month with current year and month
  //       const vehicleAge = year
  //         - parseInt(requestInfo.vehicle.vehicle_year)
  //         - (month < parseInt(requestInfo.vehicle.vehicle_month) ? 1 : 0);
  //       setIsOlderThan10years(vehicleAge >= 10);
  //     }
  //   }
  // }, [requestInfo]);

  const saveVehicleAmount = (type) => {
    addVehicleAmount(requestToken, refresh, vehicleAmount[type.id], setVehicleAmount);
  };

  // useEffect(() => {
  //   if (requestInfo?.vehicle?.value) {
  //     addVehicleAmount(requestToken, refresh, requestInfo.vehicle.value, setVehicleAmount);
  //   }
  // }, [requestInfo?.vehicle?.value]);

  if (loading) {
    return <PageLoading />;
  }

  const coverages = coveragesUtil.calculateCommonCoverages(
    requestInfo?.product_id ?? 1,
    quotes ?? [],
  );

  // const options = {
  //   arrowColor: '#fff',
  //   backgroundColor: '#fff',
  //   beaconSize: 36,
  //   overlayColor: 'rgba(0, 0, 0, 0.5)',
  //   spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
  //   textColor: '#333',
  //   zIndex: 99999,
  // };

  const fetchQuotes = () => {
    loadAutoQuotes(requestToken);
  };

  const selectQuotation = (quoteId, closeButton) => {
    const quote = quotes.find((q) => q.id === quoteId);
    if (
      quote
      && quote.payment_frequency != requestInfo.payment_frequency
      && quote.quote_type === 'res_civile'
    ) {
      confirmAlert(
        `La frequenza di pagamento di questa quotazione è ${quote.payment_frequency == 1 ? 'annuale' : 'semestrale'}, mentre la frequenza di pagamento selezionata nella richiesta è ${requestInfo.payment_frequency == 1 ? 'annuale' : 'semestrale'}. Sei sicuro di voler aggiungere questa quotazione al carrello? Questo aggiornerà anche la frequenza di pagamento della richiesta.`,
        () => addQuoteAutoToCart(quoteId, fetchQuotes, modifyData, closeButton),
      );
    } else {
      confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addQuoteAutoToCart(quoteId, fetchQuotes, modifyData, closeButton));
    }
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeQuoteAutoFromCart(quoteId, fetchQuotes, modifyData));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let primaGuaranteesPrices = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    if (processingQuote.company_id === 2) {
      processingQuote.guarantees.forEach((guarantee) => {
        primaGuaranteesPrices += parseFloat(guarantee.amount) || 0;
      });
    }

    return (
      quoteInProccessAmount
      + primaGuaranteesPrices
      + risksTotalAmount
    ).toFixed(2);
  };

  const handleRequestSave = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    if (requestInfo.product_id == 1) {
      navigate(`/quotes/auto/purchase/${requestToken}`);
    } else if (requestInfo.product_id == 3) {
      navigate(`/quotes/autocarro/purchase/${requestToken}`);
    }
  };

  return error !== null ? (
    <ErrorComponent error={error} />
  ) : (
    <>
      {/* <Joyride
            steps={steps}
            run={run}
            continuous
            showBeacon={showBeacon}
            locale={{
              back: 'Indietro',
              close: 'Chiudi',
              last: 'Fine',
              next: 'Prossima',
              open: 'Apri il modale',
              restart: 'Riavvia il tour ',
              skip: 'Salta',
            }}
            styles={{
              options,
              buttonNext: {
                backgroundColor: '#00a651',
                outline: 'none',
              },
              buttonBack: {
                color: '#00a651',
                outline: 'none',
              },
              beaconInner: {
                backgroundColor: '#00a651',
              },
              beaconOuter: {
                borderColor: '#00a651',
                backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
              },
              buttonSkip: {
                outline: 'none',
              },
              buttonClose: {
                outline: 'none',
              },
            }}
            callback={(data) => handleCallbackRcQuotes(data, steps, setState)}
            showSkipButton
            showProgress
            disableScrolling
          /> */}
      {showGuaranteesModal && (
        <GuaranteesModal
          setShowGuaranteesModal={setShowGuaranteesModal}
          coverages={coverages}
          requestToken={requestToken}
        />
      )}

      {showConversationModal && (
        <ConversationModal
          requestId={requestInfo?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location={requestInfo?.product_id == 1 ? 'quotation_auto_result' : 'quotation_autocarro_result'}
        />
      )}

      <V2FontImport />
      <RcQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <VehicleSummaryCard
              insuranceRequest={requestInfo}
              modificaDati={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestSave()}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12">
              <EstimateContainer>
                <ActionButtonsRow $spread={requestInfo.product_id === '1'}>
                  {requestInfo.product_id === '1' && (
                    <TonalActionButton
                      type="button"
                      onClick={() => toggleAutoReportChart()}
                    >
                      <ChartIcon />
                      Consulenza Report
                    </TonalActionButton>
                  )}
                  <OutlineActionButton
                    type="button"
                    onClick={() => {
                      setShowConversationModal(true);
                      if (thread?.unreadMessages > 0) silentRefresh();
                    }}
                  >
                    <ChatIcon />
                    Contatta il Backoffice
                    {thread?.unreadMessages > 0 && (
                      <ActionButtonBadge>
                        {thread.unreadMessages}
                        <span className="visually-hidden">messaggi non letti</span>
                      </ActionButtonBadge>
                    )}
                  </OutlineActionButton>
                  {/* {requestInfo.selling_point === 0
                    && (
                      <>
                        <SellingDistanceButton className="btn btn-success mb-2" onClick={() => setShowSellingDistanceModal(true)}>Crea link per vendita a distanza</SellingDistanceButton>
                        {showSellingDistanceModal === true
                          && (
                            <SellingDistanceModal
                              requestToken={requestToken}
                              closeModal={() => setShowSellingDistanceModal(false)}
                              loadResults={() => loadAutoQuotes(requestToken)}
                            />
                          )}
                      </>
                    )}
                  {requestInfo.selling_point === 1
                    && (
                      <div className="d-flex align-items-center ">
                        <div className="btn btn-success m-2" onClick={() => copySellingDistanceLink()} title="Copia collegamento per il cliente">
                          <FontAwesomeIcon icon={faCopy} />
                        </div>
                        <SellingDistanceLink>{getSellingDistanceLink()}</SellingDistanceLink>
                      </div>
                    )} */}
                </ActionButtonsRow>
                {showConsulenzaReport ? (
                  loadingReport ? (
                    <div className="d-flex justify-content-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Caricando...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="mt-2">
                      <h4 className="text-center fw-bold mb-0">
                        Analisi Bisogni Cliente
                      </h4>
                      <Chart
                        options={optionsChart}
                        series={series}
                        height="350px"
                        type="bar"
                      />
                    </div>
                  )
                ) : (
                  ''
                )}
                {/* <div className="d-flex flex-column align-items-end justify-content-end gap-2">
                      <div>
                        {localStorage.getItem('quoteNewResult') === 'done' && (
                          <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                            <button className="btn btn-success px-2 py-1">Tutorial</button>
                          </div>
                        )}
                      </div>
                    </div> */}
              </EstimateContainer>
            </div>
          </div>

          {(requestInfo && requestInfo.product_id == 1 && !requestInfo.is_renewal) && (
            <>
              {(allScrapperResulsGotten.genial_received === false || allScrapperResulsGotten.verti_received === false || allScrapperResulsGotten.nobis_received === false || allScrapperResulsGotten.facile_received === false || allScrapperResulsGotten.bene_assicurazioni_received === false) && (
                <div className="row my-3">
                  <div className="col-12">
                    <LambdaLoaderCard />
                  </div>
                </div>
              )}
            </>
          )}

          {requestInfo && requestInfo.product_id == 3 && !requestInfo.is_renewal && (
            <>
              {(allScrapperResulsGotten.genial_received === false || allScrapperResulsGotten.linear_received === false || allScrapperResulsGotten.verti_received === false || allScrapperResulsGotten.facile_received === false) && (
                <div className="row my-3">
                  <div className="col-12">
                    <LambdaLoaderCard />
                  </div>
                </div>
              )}
            </>
          )}

          {quotations && !quotations.res_civile
            && (
              <AvvisoAlert role="alert">
                <h4>Avviso!</h4>
                <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </AvvisoAlert>
            )}

          {quotations && quotations.res_civile && (
            <>
              <RiskContainer className="mb-4 ">
                {processingQuote?.company_id === 2
                  ? (
                    // Case 1: company_id === 2
                    [{ id: 'res_civile', name: 'Responsabilita Civile' }].map((type, index) => (
                      quotations?.[type.id] && (
                        <RiskCardBlock
                          key={index}
                          type={type}
                          requestInfo={requestInfo}
                          riskQuotations={riskQuotations}
                          processingQuote={processingQuote}
                          removeItemFromCart={removeItemFromCart}
                          refresh={refresh}
                          guaranteesPrima={guaranteesPrima}
                        />
                      )
                    ))
                  )
                  : (
                    // Case 2: all other companies
                    quoteTypes.map((type, k) => {
                      const showVehicleValueInput = isVehicleValueType(type.id)
                        && requestInfo.product_id == 1 && requestInfo.vehicle && requestInfo.vehicle.value === null;

                      const showRiskCard = quotations?.[type.id] && shouldRenderRiskCard(processingQuote, type.id, quotations);

                      const showBonusProtetto = processingQuote?.company_id === 18 && type.id === 'bonus_protetto';
                      //! WHY THIS CHECK
                      // if (processingQuote != null && processingQuote.company_id == 1001 && type.id != 'res_civile') {
                      //   return null;
                      // }
                      return (
                        <React.Fragment key={k}>
                          {showRiskCard && (
                            <RiskCardBlock
                              type={type}
                              requestInfo={requestInfo}
                              riskQuotations={riskQuotations}
                              processingQuote={processingQuote}
                              removeItemFromCart={removeItemFromCart}
                              refresh={refresh}
                              guaranteesPrima={guaranteesPrima}
                            />
                          )}

                          {showBonusProtetto && (
                            <RiskCardBlock
                              type={type}
                              requestInfo={requestInfo}
                              riskQuotations={riskQuotations}
                              processingQuote={processingQuote}
                              removeItemFromCart={removeItemFromCart}
                              refresh={refresh}
                              guaranteesPrima={guaranteesPrima}
                            />
                          )}

                          {showVehicleValueInput && (
                            <VehicleValueInputCard
                              type={type}
                              requestInfo={requestInfo}
                              vehicleAmount={vehicleAmount}
                              setVehicleAmount={setVehicleAmount}
                              saveVehicleAmount={saveVehicleAmount}
                              riskQuotations={riskQuotations}
                            />
                          )}
                        </React.Fragment>
                      );
                    })
                  )}

                {processingQuote !== null && processingQuote.company_id === 2 && (
                  <>
                    {processingQuote?.quotation_data_prima?.quotation_data_prima_guarantees.map(
                      (quote) => {
                        if (quote.slug === 'rca') return null;

                        // If a Nobis alternative is the one actually selected for
                        // this guarantee (picked from this same card's own modal),
                        // render the merge card here, in place of Prima's own
                        // (unselected) catalog card, so the risk stays in the same
                        // list position instead of jumping to the end.
                        const mergeMatch = primaMergeQuoteTypes.find(
                          (m) => m.primaSlug === quote.slug,
                        );
                        const isActiveInPrima = processingQuote?.guarantees?.some(
                          (g) => g.guarantees_slug === quote.slug,
                        );
                        const nobisSelectedInstead = mergeMatch
                          && !isActiveInPrima
                          && Array.isArray(riskQuotations?.[mergeMatch.id])
                          && riskQuotations[mergeMatch.id].some((q) => q.company_id === 1001);

                        if (nobisSelectedInstead) {
                          const type = quoteTypes.find((t) => t.id === mergeMatch.id);
                          if (!type) return null;

                          return (
                            <RiskCardBlock
                              key={quote.slug}
                              type={type}
                              requestInfo={requestInfo}
                              riskQuotations={riskQuotations}
                              processingQuote={processingQuote}
                              removeItemFromCart={removeItemFromCart}
                              refresh={refresh}
                              guaranteesPrima={guaranteesPrima}
                            />
                          );
                        }

                        return (
                          <RiskCardBlockPrima
                            key={quote.slug}
                            quote={quote}
                            requestInfo={requestInfo}
                            processingQuote={processingQuote}
                            primaQuoteTypes={primaQuoteTypes}
                            guaranteesPrima={guaranteesPrima}
                          />
                        );
                      },
                    )}

                    {primaMergeQuoteTypes.map((mergeType) => {
                      // This only handles merge types that never appear in
                      // Prima's own catalog above at all (primaSlug === null,
                      // e.g. ricordo_terzi_da_incendio, or a slug this quote's
                      // Prima catalog doesn't list) — types with a catalog entry
                      // are already handled in place, in the loop above.
                      const catalogEntryExists = mergeType.primaSlug !== null
                        && processingQuote?.quotation_data_prima
                          ?.quotation_data_prima_guarantees?.some(
                            (g) => g.slug === mergeType.primaSlug,
                          );
                      if (catalogEntryExists) return null;

                      const coveredByPrima = mergeType.primaSlug !== null
                        && processingQuote?.guarantees?.some(
                          (g) => g.guarantees_slug === mergeType.primaSlug,
                        );
                      if (coveredByPrima) return null;

                      const hasNobisQuote = Array.isArray(quotations?.[mergeType.id])
                        && quotations[mergeType.id].some((q) => q.company_id === 1001);
                      if (!hasNobisQuote) return null;

                      const type = quoteTypes.find((t) => t.id === mergeType.id);
                      if (!type) return null;

                      return (
                        <RiskCardBlock
                          key={mergeType.id}
                          type={type}
                          requestInfo={requestInfo}
                          riskQuotations={riskQuotations}
                          processingQuote={processingQuote}
                          removeItemFromCart={removeItemFromCart}
                          refresh={refresh}
                          guaranteesPrima={guaranteesPrima}
                        />
                      );
                    })}
                  </>
                )}
              </RiskContainer>

              {quoteTypes.map((type, index) => (
                <ModalQuotes
                  refresh={refresh}
                  processingQuote={processingQuote}
                  key={index}
                  type={type}
                  addingQuote={addingQuote}
                  sortBy={sortBy}
                  sortQuotes={sortQuotes}
                  currentQuotes={currentQuotes}
                  requestInfo={requestInfo}
                  counter={counter}
                  quotations={quotations}
                  requestToken={requestToken}
                  selectQuotation={selectQuotation}
                  guaranteesPrima={guaranteesPrima}
                  preventivas_quotes={preventivas_quotes}
                  riskQuotes={[riskQuotations]}
                />
              ))}
              {processingQuote !== null
                && processingQuote.company_id === 2
                && primaQuoteTypes.map((type, index) => (
                  <ModalQuotesPrima
                    processingQuote={processingQuote}
                    key={index}
                    type={type}
                    addingQuote={addingQuote}
                    sortBy={sortBy}
                    sortQuotes={sortQuotes}
                    requestInfo={requestInfo}
                    requestToken={requestToken}
                    guaranteesPrima={guaranteesPrima}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    riskQuotations={riskQuotations}
                  />
                ))}
            </>
          )}
          {failedQuotes !== null && failedQuotes.length > 0 && (
            <FailedQuotationsComponent failedQuotes={failedQuotes} />
          )}
        </div>
      </RcQuotesStyles>
    </>
  );
}

export default RcQuotes;
